import { render, staticRenderFns } from "./social-media.vue?vue&type=template&id=43272533&scoped=true"
import script from "./social-media.vue?vue&type=script&lang=js"
export * from "./social-media.vue?vue&type=script&lang=js"
import style0 from "./social-media.vue?vue&type=style&index=0&id=43272533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43272533",
  null
  
)

export default component.exports